var drawerSlider = function(options) {
  var altTriggers = options.triggers || [];
  this.group = document.querySelector(options.group);
  this.buildTriggers(altTriggers);
};

drawerSlider.prototype.buildTriggers = function(altTriggers) {
  this.triggers = [];
  var triggerList = this.group.querySelectorAll(".drawer-trigger");

  this.addTriggers(triggerList);

  for (var i = 0; i < altTriggers.length; i++) {
    var altList = document.querySelectorAll(altTriggers[i]);
    this.addTriggers(altList);
  }
};

drawerSlider.prototype.addTriggers = function(triggers) {
   for (var i = 0; i < triggers.length; i++) {
    this.triggers.push(triggers[i]);
  }
}

drawerSlider.prototype.attachClick = function() {
 this.triggers.forEach(function(trigger) {
   var listener = this.listen.bind(this);
   trigger.addEventListener("click", listener);
  }, this);
};

drawerSlider.prototype.listen = function(event) {
  event.preventDefault();
  this.setDrawers(event.target.dataset.target);

  this.addAnimation();
  this.current && this.moveCurrent();
  this.moveTarget();
};

drawerSlider.prototype.addAnimation = function() {
  if (!this.current || this.target.contains(this.current)) {
    this.animate(this.target);
  } else {
    this.animate(this.current);
  }
}

drawerSlider.prototype.setDrawers = function(targetSelector) {
  this.current = this.group.querySelector(".drawer.open");
  this.target = document.querySelector(targetSelector);
}

drawerSlider.prototype.moveCurrent = function() {
  if (this.target.contains(this.current)) {
    this.close(this.current);
  } else {
    this.extend(this.current);
  }
}

drawerSlider.prototype.moveTarget = function() {
  if (this.target === this.current) {
    this.close(this.target);
  } else {
    !this.isSmall() && this.current && this.close(this.current);
    //    this.current && this.close(this.current);
    this.open(this.target);
  }
}

drawerSlider.prototype.animate = function(drawer) {
  drawer.classList.add("animating");
  drawer.addEventListener("transitionend", function(event) {
    event.target.classList.remove("animating");
    event.target.classList.contains("closed") &&  event.target.classList.remove("active");
  });
};

drawerSlider.prototype.open = function(drawer) {
  // drawer.closest(".drawer-container").classList.add("open");
  drawer.classList.add("active");
  drawer.classList.add("open");
  drawer.classList.remove("extended");
  drawer.classList.remove("closed");
}

drawerSlider.prototype.close = function(drawer) {
// drawer.closest(".drawer-container").classList.remove("open");
  drawer.classList.add("closed");
  drawer.classList.remove("active");
  drawer.classList.remove("extended");
  drawer.classList.remove("open");
}

drawerSlider.prototype.extend = function(drawer) {
  drawer.classList.add("extended");
  drawer.classList.remove("closed");
  drawer.classList.remove("open");
}

module.exports = drawerSlider;

drawerSlider.prototype.isSmall = function() {
  return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 1000;
}; 
